import AppView from './AppView'
import { SPREADSHEET } from 'Types'

class SpreadSheetView extends AppView
  @className = 'SpreadSheetView'

  constructor: (id) ->
    super(id)
    @set('type', SPREADSHEET)

  buildQueries: ->
    {
      query: new Weaver.Sparql(@get('query'))
    }

export default SpreadSheetView
